import { OTTERFOLIO_THEME } from "./theme";

interface Option {
  key: string;
  label: string;
}

interface Props {
  options: Option[];
  active: string;
  onChange: (k: string) => void;
}

export function ToggleGroup({ options, active, onChange }: Props) {
  return (
    <div style={{ display: "flex", gap: 4 }}>
      {options.map((o) => {
        const isActive = active === o.key;
        return (
          <button
            key={o.key}
            type="button"
            onClick={() => onChange(o.key)}
            style={{
              background: isActive ? OTTERFOLIO_THEME.primary : "transparent",
              color: isActive ? OTTERFOLIO_THEME.bg : OTTERFOLIO_THEME.textMuted,
              border: `1px solid ${OTTERFOLIO_THEME.cardBorder}`,
              padding: "3px 8px",
              borderRadius: 4,
              fontSize: 10,
              cursor: "pointer",
              fontWeight: isActive ? 700 : 400,
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
